export const haafCoordinatorConfig = {
  sidebarNav: [
    {
      title: "Overview",
      href: "/haaf-coordinator/overview",
      icon: "layout-dashboard",
    },
    {
      title: "HAF Payments",
      href: "/haaf-coordinator/haf-payments",
      icon: "banknote",
    },
    {
      title: "Settings",
      href: "/haaf-coordinator/settings",
      icon: "settings",
    },
  ],
};
